<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear absolute color="success" height="4" indeterminate></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="deep-gl" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ $t("TEAMS.VIEW") }}</v-toolbar-title>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <div class="preview-list">
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.ID") }}:</span>
                  <span class="preview-value">{{ requestData.id || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.NAME") }}:</span>
                  <span class="preview-value">{{ requestData.name || "-" }}</span>
                </div>
                <div class="preview-row preview-row--stacked">
                  <span class="preview-label">{{ $t("TEAMS.USERS") }}:</span>
                  <div class="preview-value">
                    <template v-if="requestData.users?.length">
                      <div v-for="user in requestData.users" :key="user.id">
                        {{ user.name }}<span v-if="user.email"> ({{ user.email }})</span>
                      </div>
                    </template>
                    <span v-else>-</span>
                  </div>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="hasPermissions('teams-edit')"
                color="primary"
                class="mr-2"
                :to="{ name: 'edit-team', params: { id: requestData.id || $route.params.id } }"
              >
                {{ $t("GENERAL.LABELS.EDIT_BUTTON") }}
              </v-btn>
              <v-btn color="warning" @click="back">{{ $t("GENERAL.LABELS.BACK_BUTTON") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { GET_TEAM_REQUEST } from "@/store/teams.module";
import { SHOW_SNACK } from "@/store/snack.module";

export default {
  name: "ViewTeam",
  data() {
    return {
      tab: "tab-1",
      isProcessing: false,
      requestData: {},
    };
  },
  mounted() {
    this.loadTeam();
  },
  methods: {
    back() {
      this.$router.push({ name: "teams" });
    },
    loadTeam() {
      this.isProcessing = true;
      this.$store
        .dispatch(GET_TEAM_REQUEST, this.$route.params.id)
        .then((response) => {
          this.requestData = response || {};
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.UNEXPECTED_ERROR"),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>

<style scoped>
.preview-row--stacked {
  align-items: flex-start;
}
</style>
